module.exports = __webpack_public_path__ + "static/img/hall04.496d952.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/02/hall04.jpg
// module id = 78XK
// module chunks = 1